<template>
  <div class="Interview_typesetting">


    <div class="Interview_typesetting_top" style="margin-left: 20px;padding-top: 20px;">
      <el-select v-model="value" placeholder="请选择" @change="room_switch()">
        <el-option v-for="item in options" :key="item.KeyNo" :label="item.Name" :value="item.KeyNo"></el-option>
      </el-select>
    </div>

    <el-calendar v-model="currentDate">
      <template slot="dateCell" slot-scope="{date, data}">
        <div class="Interview_typesetting_nav" @click="romm_details(data.day, data.TencentLink)">
          <p class="p0" :class="data.isSelected ? 'is-selected' : ''">
            {{ data.day.split('-').slice(2).join('-') }}
          </p>
          <div v-for="item in datas" :key="item.id" class="yudiv">
            <p v-if="item.id == data.day.split('-').slice(0).join('-')" class="p1">
              <span style="margin-left: 5px;color: rgba(43, 186, 100, 1);">上午</span> 
              <span style="font-size: 12px;color: rgba(40, 40, 40, 1);margin-left: 22px;">已约 :</span> 
              <span style="font-size: 12px;margin-left: 8px;">{{ item.zs }}</span>
            </p>
            <p v-if="item.id == data.day.split('-').slice(0).join('-')" class="p2">
              <span style="margin-left: 5px;color: rgba(255, 141, 26, 1);">下午</span> 
              <span style="font-size: 12px;color: rgba(40, 40, 40, 1);margin-left: 22px;">已约 :</span>
              <span style="font-size: 12px;margin-left: 8px;">{{ item.zw }}</span>
            </p>
            <p v-if="item.id == data.day.split('-').slice(0).join('-')" class="p3">
              <span style="margin-left: 5px;color: rgba(31, 144, 242, 1);">晚上</span> 
              <span style="font-size: 12px;color: rgba(40, 40, 40, 1);margin-left: 22px;">已约 :</span> 
              <span style="font-size: 12px;margin-left: 8px;">{{ item.ws }}</span>
            </p>
          </div>
        </div>
      </template>
    </el-calendar>

    <el-drawer :visible.sync="drawer" size="55%">

      <div>
        <div class="Interview_typesetting_top" style="margin-left: 20px;">
          <el-select  v-model="value2" placeholder="请选择" @change="room_switch2()">
            <el-option v-for="item in options" :key="item.KeyNo" :label="item.Name" :value="item.KeyNo"></el-option>
          </el-select>
          <el-date-picker style="margin-left: 50px;" v-model="times" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="dataclick1()"></el-date-picker>
        </div>

        <h2 style="margin-left: 20px;padding-top: 20px;">上午</h2>

        <ul class="Interview_typesetting_right">
          <li v-for='(item, index) in neilist.sw' :key="item.ScheduleNo" >
            <div v-if="item.Status == 1" @click='handlerLi1(index, item.ScheduleNo)' :class="flag1 == index ? 'currents' : 'origins'">
              <span :title="item.UserName ? item.UserName : '-' " style="color: rgba(51, 51, 51, 1);margin-left: 14px;width: 25%;display: inline-block;height: 50px;overflow: hidden;">{{ item.UserName ? item.UserName : "-" }}</span>
              <span style="width: 40%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Begin + '-' + item.End }}</span>
              <span style="width: 30%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Phone ? item.Phone : '-' }}</span>
            </div>
            <div v-else style="background-color: rgba(242, 242, 242, 1);color: rgba(153, 153, 153, 1);"> 
              <span :title="item.UserName ? item.UserName : '-' " style="color: rgba(51, 51, 51, 1);margin-left: 14px;width: 25%;display: inline-block;height: 50px;overflow: hidden;">{{ item.UserName ? item.UserName : "-" }}</span>
              <span style="width: 40%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Begin + '-' + item.End }}</span>
              <span style="width: 30%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Phone ? item.Phone : '-' }}</span>
            </div>
          </li>
        </ul>
        <h2 style="margin-left: 20px;padding-top: 20px;">中午</h2>

        <ul class="Interview_typesetting_right">
          <li v-for='(item, index) in neilist.xw' :key="item.ScheduleNo">

            <div v-if="item.Status == 1" @click='handlerLi2(index, item.ScheduleNo)' :class="flag2 == index ? 'currents' : 'origins'">
              <span :title="item.UserName ? item.UserName : '-' " style="color: rgba(51, 51, 51, 1);margin-left: 14px;width: 25%;display: inline-block;height: 50px;overflow: hidden;">{{ item.UserName ? item.UserName : "-" }}</span>
              <span style="width: 40%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Begin + '-' + item.End }}</span>
              <span style="width: 30%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Phone ? item.Phone : '-' }}</span>
            </div>

            <div v-else style="background-color: rgba(242, 242, 242, 1);color: rgba(153, 153, 153, 1);">
              <span :title="item.UserName ? item.UserName : '-' " style="color: rgba(51, 51, 51, 1);margin-left: 14px;width: 25%;display: inline-block;height: 50px;overflow: hidden;">{{ item.UserName ? item.UserName : "-" }}</span>
              <span style="width: 40%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Begin + '-' + item.End }}</span>
              <span style="width: 30%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Phone ? item.Phone : '-' }}</span>
            </div>

          </li>
        </ul>

        <h2 style="margin-left: 20px;padding-top: 20px;">晚上</h2>

        <ul class="Interview_typesetting_right">
          <li v-for='(item, index) in neilist.ws' :key="item.ScheduleNo" >
            <div v-if="item.Status == 1" @click='handlerLi3(index, item.ScheduleNo)' :class="flag3 == index ? 'currents' : 'origins'">
              <span :title="item.UserName ? item.UserName : '-' " style="color: rgba(51, 51, 51, 1);margin-left: 14px;width: 25%;display: inline-block;height: 50px;overflow: hidden;">{{ item.UserName ? item.UserName : "-" }}</span>
              <span style="width: 40%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Begin + '-' + item.End }}</span>
              <span style="width: 30%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Phone ? item.Phone : '-' }}</span>
            </div>

            <div v-else style="background-color: rgba(242, 242, 242, 1);color: rgba(153, 153, 153, 1);">
              <span :title="item.UserName ? item.UserName : '-' " style="color: rgba(51, 51, 51, 1);margin-left: 14px;width: 25%;display: inline-block;height: 50px;overflow: hidden;">{{ item.UserName ? item.UserName : "-" }}</span>
              <span style="width: 40%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Begin + '-' + item.End }}</span>
              <span style="width: 30%;display: inline-block;height: 50px;overflow: hidden;">{{ item.Phone ? item.Phone : '-' }}</span>
            </div>

          </li>
        </ul>

        <div style="height: 160px;text-align: center;padding-top: 40px;">
          <el-button v-if="pdyy" type="primary" plain @click="adjust()">预约调整</el-button>
          <!-- <el-button type="primary" plain @click="write()">填写访谈记录</el-button>
          <el-button type="primary" @click="goin()">进入访谈</el-button> -->
        </div>

        <!-- 里面的抽屉1111111111111111111111111111111111111111111111111111111111111111111111111111111111111 -->

        <el-drawer :append-to-body="true" :before-close="handleClose" :visible.sync="innerDrawer" size="40%">

          <div class="Interview_typesetting_neitop" style="margin-left: 20px;">

            <el-select  v-model="value3" placeholder="请选择" @change="room_switch3()">
              <el-option v-for="item in options" :key="item.KeyNo" :label="item.Name" :value="item.KeyNo"></el-option>
            </el-select>

            <el-date-picker  style="margin-left: 50px;" v-model="times3" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="dataclick3()"></el-date-picker>
          </div>

          <h2 style="margin-left: 20px;padding-top: 20px;">上午</h2>

          <ul class="Interview_typesetting_neiright">
            <li v-for='(item, index) in neilist3.sw' :key="item.index" >
              <p @click='handlerLi4(index, item.ScheduleNo)' :class="flag4 == index ? 'currents' : 'origins'">
                {{ item.Begin + '-' + item.End }}
              </p>
            </li>
          </ul>

          <h2 style="margin-left: 20px;padding-top: 20px;">中午</h2>

          <ul class="Interview_typesetting_neiright">

            <li v-for='(item, index) in neilist3.xw' :key="item.index" >
              <p  @click='handlerLi5(index, item.ScheduleNo)' :class="flag5 == index ? 'currents' : 'origins'">
                {{ item.Begin + '-' + item.End }}
              </p>
            </li>

          </ul>

          <h2 style="margin-left: 20px;padding-top: 20px;">晚上</h2>

          <ul class="Interview_typesetting_neiright">
            <li v-for='(item, index) in neilist3.ws' :key="item.index" >
             <p  @click='handlerLi6(index, item.ScheduleNo)' :class="flag6 == index ? 'currents' : 'origins'">
              {{ item.Begin + '-' + item.End }}
             </p>
            </li>
          </ul>

          <div style="height: 160px;text-align: center;padding-top: 40px;">
            <el-button @click="innerDrawer = false" type="primary" plain>取消</el-button>
            <el-button type="primary" @click="adjustment()">确定调整</el-button>
          </div>

        </el-drawer>

      </div>

    </el-drawer>

  </div>
</template>
<script>
export default {
  data() {
    return {
      pdyy:true,
      goinurl:'',
      ScheduleNo: '',
      newScheduleNo: '',//新的id
      KeyNo: '',
      KeyNo2: '',
      ValidStartDate: '',
      neilist:[],//天列表
      neilist3: [],//天列表
      StartDate: '',
      currentDate: new Date([this.$route.query.ValidStartDate][0]),
      current: 'current',
      flag: 99,
      flag1: 99,
      flag2: 99,
      flag3: 99,
      flag4: 99,
      flag5: 99,
      flag6: 99,
      origin: 'origin',
      drawer: false,
      innerDrawer: false,
      times:'2023-05-12',
      times3: '2023-05-12',
      options: [],
      value: '',
      value2: '',
      value3: '',
      datas: [],
    }
  },
  mounted() {
    this.KeyNo = [this.$route.query.id][0];
    this.KeyNo2 = [this.$route.query.id][0];
    this.value = [this.$route.query.id][0];
    this.ValidStartDate = [this.$route.query.ValidStartDate][0].slice(0, 7);;
    this.loading();
    this.$Http_Post('EmphasisClarification/GetInterviewRoomList', {HistoryFlag:"1"}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.value = Number([this.$route.query.id][0]);
        this.value2 = Number([this.$route.query.id][0]);
        this.options = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
  watch: {
    currentDate: {//上下月点击事件监听
      handler(newVal, objVal) {
        if (newVal) {
          this.ValidStartDate = this.format(newVal.getTime());
          this.loading();
        }
      },
    },
    innerDrawer() {
      if (!this.innerDrawer) {
        this.flag4 = 99
        this.flag5 = 99
        this.flag6 = 99

        this.times3 = ''
        this.value3 = ''
      }
    },
    drawer() {
      if (!this.drawer) {
        this.flag= 99
        this.flag1 = 99
        this.flag2 = 99
        this.times = ''
        this.KeyNo2 = ''
      }
    }
  },
  methods: {
    goin() {
      window.open(this.goinurl);
    },
    write() {
      this.$router.push('/Client/EmphasisClarification');
    },
    add0(m){ return m < 10 ? '0' + m : m },
    format(shijianchuo){//shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + '-' + this.add0(m);
    },
    handlerLi(i) {
      this.flag = i;
    },
    adjustment() {//确定调整
      this.$Http_Post('EmphasisClarification/UpdateInterviewRoomSchedule', { OriginalNo: this.ScheduleNo, TargetNo: this.newScheduleNo }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.innerDrawer = false;
          this.getloading();
          this.getloading3();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    dataclick1() {//二级日期切换
      this.ScheduleNo = '';
      this.flag1 = 99;
      this.flag2 = 99;
      this.flag3 = 99;
      this.getloading();
    },
    room_switch2() {//二级会议室切换
      for (var i = 0; i <= this.options.length; i++) {
        if (this.value2 == this.options[i].KeyNo) {
          this.goinurl = this.options[i].TencentLink
          break
        }
      }

      this.KeyNo2 = this.value2;
      this.ScheduleNo = '';
      this.flag1 = 99;
      this.flag2 = 99;
      this.flag3 = 99;
      this.getloading();
    },
    dataclick3() {//三级时间切换
      this.getloading3();
    },
    room_switch3() {//三级会议室切换
      this.getloading3();
    },
    handlerLi4(i, newScheduleNo) {//三级会议室切换
      this.newScheduleNo = newScheduleNo;
      this.flag4 = i;
      this.flag5 = 99;
      this.flag6 = 99;
      this.getloading();
    },
    handlerLi5(i, newScheduleNo) {//三级会议室切换
      this.newScheduleNo = newScheduleNo;
      this.flag4 = 99;
      this.flag5 = i;
      this.flag6 = 99;
      this.getloading();
    },
    handlerLi6(i, newScheduleNo) {//三级会议室切换
      this.newScheduleNo = newScheduleNo;
      this.flag4 = 99;
      this.flag5 = 99;
      this.flag6 = i;
      this.getloading();
    },
    handlerLi1(i, handlerLi1) {
      this.flag1 = i;
      this.flag2 = 99;
      this.flag3 = 99;
      this.ScheduleNo = handlerLi1;
    },
    handlerLi2(i, handlerLi1) {
      this.flag2 = i;
      this.flag1 = 99;
      this.flag3 = 99;
      this.ScheduleNo = handlerLi1;
    },
    handlerLi3(i, handlerLi1) {
      this.flag3 = i;
      this.flag1 = 99;
      this.flag2 = 99;
      this.ScheduleNo = handlerLi1;
    },
    room_switch() {//会议室切换
      this.KeyNo = this.value;
      this.KeyNo2 = this.value;
      this.loading();
    },
    adjust() {//预约调整
      if (this.ScheduleNo) {
        this.value3 = Number(this.value2);
        this.times3 = this.times;
        this.innerDrawer = true;
        this.getloading3();
      } else {
        alert("请选择需要调整的时间段");
      }
    },
    romm_details(val, TencentLink) {//日详情查看
      this.StartDate = val;
      this.value2 = Number(this.KeyNo);
      this.times = val;
      this.KeyNo2 = this.KeyNo;
      this.getloading();
      this.drawer = true;
    },
    handleClose(done) {
      this.$confirm('还有未保存的工作哦确定关闭吗？').then(_ => {
        done();
      })
      .catch(_ => { });
    },
    loading() {
      this.$Http_Post('EmphasisClarification/GetInterviewRoomSchedule',{ CheckTime : this.ValidStartDate, RoomNo: this.KeyNo }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.datas = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    getloading() {

      // 现在时间 >= 选中时间

      if (Number(new Date().toLocaleDateString().slice(0, 4)) >= Number(this.times.slice(0, 4)) && Number(new Date().toLocaleDateString().slice(5, 6)) >= Number(this.times.slice(5, 7)) && Number(new Date().toLocaleDateString().slice(7, 9)) >= Number(this.times.slice(8, 10))) {
        this.pdyy = false
      } else {
        this.pdyy = true
      }

      this.$Http_Post('EmphasisClarification/GetInterviewRoomScheduleInfo', { CheckTime: this.times, RoomNo: this.KeyNo2 }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.neilist = res.Data;
          this.goinurl = res.Data.TencentLink;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    getloading3() {
      this.$Http_Post('EmphasisClarification/GetInterviewRoomScheduleInfo', { CheckTime: this.times3, RoomNo: this.value3 }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.neilist3 = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
  },
}
</script>
<style>
.Interview_typesetting{width: 100%;height: 100%;background-color: #fff;}
.Interview_typesetting .Interview_typesetting_right{width: 94%;margin-left: 3%;margin-top: 10px;zoom: 1;}
.Interview_typesetting .Interview_typesetting_right li{float: left;width: 50%;height: 50px;line-height: 50px;cursor:pointer;border-bottom: 1px solid #dcdcdc;}
.Interview_typesetting .Interview_typesetting_right li:hover{background-color: rgba(230, 240, 250, 1);}
.Interview_typesetting .Interview_typesetting_right::after{display: block;clear: both;content: "";visibility: hidden;height: 0;}
.Interview_typesetting_neiright{}
.Interview_typesetting_neiright li{width: 29%;float: left;margin-left: 4%;height: 40px;line-height: 40px;background-color: rgba(242, 242, 242, 1);text-align: center;margin-top: 20px;cursor:pointer;}
.Interview_typesetting_neiright li:hover{background-color: rgba(29, 154, 255, 1);color: #fff;}
.Interview_typesetting_neiright::after{display: block;clear: both;content: "";visibility: hidden;height: 0;}
.Interview_typesetting .el-drawer__header{margin-bottom:0px}
.Interview_typesetting .el-drawer__close-btn {border: none;cursor: pointer;font-size: 21px;color: inherit;background-color: transparent;padding-right: 10px;padding-top: 10px;}
.Interview_typesetting .Interview_typesetting_top .el-input--suffix .el-input__inner{background-color: rgba(237, 237, 237, 1);}
.Interview_typesetting_neitop .el-input--suffix .el-input__inner{background-color: rgba(237, 237, 237, 1);}
.is-selected {color: #1989FA;}
.Interview_typesetting .el-calendar-day{position: relative;}
.Interview_typesetting .el-calendar-table__row{height: 120px;}
.Interview_typesetting .el-calendar-day .p0{font-size: 20px;}
.Interview_typesetting .el-calendar-day .p1{position: absolute;height: 28px;line-height: 28px; width: 40px;width: 120px;background-color: rgba(230, 247, 237, 1);right: 8px;top: 10px;border-radius: 4px;}
.Interview_typesetting .el-calendar-day .p2{position: absolute;height: 28px;line-height: 28px; width: 40px;width: 120px;background-color: rgba(255, 239, 224, 1);right: 10px;top: 46px;border-radius: 4px;}
.Interview_typesetting .el-calendar-day .p3{position: absolute;height: 28px;line-height: 28px; width: 40px;width: 120px;background-color: rgba(225, 239, 252, 1);right: 10px;top: 82px;border-radius: 4px;}
.Interview_typesetting .el-calendar-table .el-calendar-day {height: 119px;}
.Interview_typesetting .Interview_typesetting_nav{height: 100%;}
.Interview_typesetting .el-calendar-table thead th{color: #fff;}
.currents {color: #fff !important;font-weight: bold !important;background-color: rgba(29, 154, 255, 1)!important;height: 50px;}
.origins {font-weight: normal;height: 50px;}
</style>
